import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { recoverUser } from "../api/adminapi";
import { Card, CardHeader, CardContent, CardFooter } from "components/ui/card";
import { Button } from "components/ui/button";
import { Input } from "components/ui/input";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim() || submitting) return;

    setSubmitting(true);
    try {
      await recoverUser(email.trim());
    } finally {
      setSubmitting(false);
      navigate("/login");
    }
  };

  return (
    <div className="flex justify-center items-center h-screen">
      <Card className="w-96 shadow-lg">
        <CardHeader>
          <h2 className="text-xl font-bold">Forgot Password</h2>
          <p className="text-sm text-gray-500">
            If you have forgotten your password, provide your username below and you will be
            contacted by our IT team.
          </p>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label
                htmlFor="email"
                className="block text-sm font-medium">
                Username:
              </label>
              <Input
                type="text"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="Enter your username"
                className="mt-2"
                disabled={submitting}
              />
            </div>
          </form>
        </CardContent>
        <CardFooter className="flex justify-end">
          <Button
            onClick={handleSubmit}
            disabled={!email.trim() || submitting}>
            {submitting ? "Submitting..." : "Submit"}
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
};

export default ForgotPassword;
